import { createVanIconComponent } from "./van"

const Video = createVanIconComponent("video")
export default Video
